exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".case-title {\n  width: 400px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.case-title-name {\n  width: 100px;\n}\n.title {\n  width: 400px;\n}\n.tips {\n  font-size: 11px;\n  margin-top: 10px;\n}\n.row {\n  height: 60px;\n  line-height: 60px;\n}\n.select {\n  width: 260px;\n}\n.window {\n  margin-top: 20px;\n}\n.remove {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 60px;\n  height: 20px;\n  border: 1px solid #e3e3e3;\n}\n.shop-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/pages/shopmanage/shoprenovation/feature/index.less
// module id = 2780
// module chunks = 0